const styles = theme => ({

  quizScreenContainer: {
    height: '100vh',
    backgroundColor: '#ecf2f1',
    overflow: 'auto'
  },

})

export default styles
